import React from 'react';
import styled from 'styled-components';

import { orbitColorsFor } from '../../styles';
import { pg, tint, type } from './pageStyles';

// Figma 6456:11945: 82 tall, #05090F at 88% over a 35 background blur, a 0.8 bottom rule, and the
// title 25 in from the left. The "…" menu (6456:11948) is 24 wide, 39 in from the right.
// `pg.page` is a `var()` reference with no channels for `tint`, so the 88% is applied to the dark
// reading the frame is drawn in.
const Header = styled.header`
  display: flex;
  flex: none;
  align-items: center;
  min-height: 82px;
  padding: 0 20px 0 25px;
  border-bottom: 0.8px solid ${pg.border};
  background: ${tint(orbitColorsFor('dark').surfaceConsole, 0.88)};
  -webkit-backdrop-filter: blur(35px);
  backdrop-filter: blur(35px);
`;

// 6410:9004: the title, and under it the chat's workspaces when it has any.
const TitleStack = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const Title = styled.h1`
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: ${pg.text};
  text-overflow: ellipsis;
  white-space: nowrap;
  ${type('pageTitle', 700)}
`;

// 6703:5733: Inter Bold 12 #AEBBD0.
const Subtitle = styled.p`
  margin: 0;
  overflow: hidden;
  color: #aebbd0;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${type('helping', 700)}
`;

const MenuSlot = styled.div`
  display: flex;
  flex: none;
  margin: 0 19px 0 auto;
  padding-left: 16px;
`;

export interface IOrbitPageChatHeaderProps {
  title: string;
  /** The line under the title; null draws none. */
  subtitle: string | null;
  /** The chat's "…" menu; null for a chat with no session to act on. */
  menu: React.ReactNode;
}

/** The full-page chat header, shown only while a chat is open. */
const OrbitPageChatHeader: React.FC<IOrbitPageChatHeaderProps> = ({ title, subtitle, menu }) => (
  <Header data-testid="orbit-page-chat-header">
    <TitleStack>
      <Title data-testid="orbit-page-chat-title">{title}</Title>
      {subtitle !== null ? (
        <Subtitle data-testid="orbit-page-chat-subtitle">{subtitle}</Subtitle>
      ) : null}
    </TitleStack>
    {menu !== null ? <MenuSlot>{menu}</MenuSlot> : null}
  </Header>
);

export default OrbitPageChatHeader;
